import { NgClass } from '@angular/common';
import {
    ChangeDetectionStrategy,
    Component,
    ElementRef,
    computed,
    input,
    output,
    viewChild,
} from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';
import { RouterLink } from '@angular/router';
import { IconComponent } from '@interacta-shared/ui-icons';
import { evaluateRoute } from '@interacta-shared/util-common';
import { ICommunity } from '@interacta/util-community';
import { dashboardCommunity } from '@modules/app-routing/routes';
import { CurrentLanguagePipe } from '@modules/shared-v2/pipes/current-language.pipe';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'interacta-sidebar-community',
    templateUrl: './sidebar-community.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        IconComponent,
        NgClass,
        RouterLink,
        TranslatePipe,
        MatTooltip,
        CurrentLanguagePipe,
    ],
})
export class SidebarCommunityComponent {
    readonly community = input.required<Pick<ICommunity, 'id' | 'name'>>();
    readonly selected = input(false);
    readonly expanded = input(true);
    readonly pinned = input(false);
    readonly pinVisible = input(false);
    readonly communityPinned = output<boolean>();

    readonly communityHref = computed(() =>
        evaluateRoute(`/${dashboardCommunity}/:id`, {
            id: this.community().id,
        }),
    );

    private readonly communityButton =
        viewChild<ElementRef<HTMLButtonElement>>('communityButton');

    pinClicked(): void {
        const pinned = this.pinned();
        if (pinned) this.communityButton()?.nativeElement?.focus();
        this.communityPinned.emit(!pinned);
    }
}
